<!-- eslint-disable -->
<template lang="pug">
    .transaction-preview
        .row.transaction-preview__row(v-if="transaction")
            .col-xs-12.col-md-3.transaction-preview__column
                | {{ $i18n.t('list.list_billing_' + transaction.operation) }}
            .col-xs-12.col-md-12.transaction-preview__column.transaction-preview__comment(v-if="user.isSuperadmin || user.type === 'admin' || user.isManagerOrSupport")
                template(v-if="transaction.comment")
                    | {{ transaction.comment }}
                template(v-else)
                    | {{ $i18n.t('list.list_billing_noComment') }}
            .col-xs-6.col-md-3.transaction-preview__column.transaction-preview__amount(:class="amountClass(transaction)")
                | {{ amountString(transaction.amount) }}
            .col-xs-6.col-md-3.transaction-preview__column.last-md
                | {{ transaction.createdAt | moment('DD.MM.YYYY') }}
            .col-xs-12.col-md-3.transaction-preview__column
                template(v-if="transaction.operation && transaction.user")
                    small-user-preview(:displayed-user="transaction.user", :with-avatar="false")
                template(v-else-if='transaction.userId')
                    | {{ $i18n.t('common.common_status_deleted') }}
                    | {{ deleteLabel }}
</template>

<script>
    /*eslint-disable*/
    import SmallUserPreview from '../../../profiles/default-elements/SmallUserPreview.vue';
    import {mapState} from 'vuex';

    export default {
        components: {SmallUserPreview},
        props: {
            transaction: {
                type: Object,
                default: {},
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            deleteLabel() {
                return (this.transaction.comment === 'Учитель')
                    ? this.$i18n.t('common.common_userType_teacher')
                    : this.$i18n.t('common.common_userType_student');
            }
        },
        methods: {
            amountClass (transaction) {
                return this.isProfit(transaction.amount, transaction)
                        ? 'transaction-preview__amount--positive'
                        : 'transaction-preview__amount--negative';
            },
            isProfit (amount, transaction = null) {
                if (this.user.isSuperadmin) {
                    return amount < 0 || (transaction && transaction.operation === 'payment');
                } else {
                    return amount > 0;
                }
            },
            amountString (amount, isBalance = false) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                return formatter.format(isBalance ? amount : Math.abs(amount));
            },
        }
    }
</script>

<style lang="scss" scoped>
    .transaction-preview {
        cursor: default;
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 12px 16px;
    }

    .transaction-preview__row {
        margin: -4px 0;
        @include media($md) {
            margin: -8px 0;
        }
    }

    .transaction-preview__column {
        padding: 4px 0;
        @include media($md) {
            padding: 8px 0;
        }
    }

    .transaction-preview {
        font-size: 13px;
        line-height: 16px;
    }

    .transaction-preview__amount {
        font-weight: 500;
    }

    .transaction-preview__comment {
        color: $hsl-color-gray-52;
        @include media($md) {
            order: 2;
        }
    }

    .transaction-preview__amount--positive {
        color: $hsl-color-green-58;
    }

    .transaction-preview__amount--negative {
        color: $hsl-color-red-62;
    }
</style>
